import React, { useState } from "react";
import "./chatbottest.css";
import HomeIcon from "@mui/icons-material/Home";
import { Box } from "@mui/material";

const ChatbotFooter = ({ onHomeIconClick }) => {
  const openHomePage = () => {
    // console.log("openHomePage called", onHomeIconClick); // Debugging log
    onHomeIconClick(true);
  };
  return (
    <Box className="chatbot-footer">
      <HomeIcon onClick={openHomePage} />
    </Box>
  );
};

export default ChatbotFooter;
